export const instances = {
  cookies: false,
};
